'use client'

import ListingsStandard, { SkeletonCard } from '@component/card/listings/standard'
import Pagination from '@component/pagination'
import Select from '@component/select'
import { BUILDER_PROPERTY_PRICE_RANGE, HOUSE_BATHROOMS, HOUSE_BEDROOMS } from '@config'
import useFetch from '@hooks/useFetch'
import { getPriceQuery } from '@utils'
import { assign, first, get, map, range } from 'lodash-es'
import { useCallback, useEffect, useMemo, useState } from 'react'

export default function PropertyContent({
  list,
  suburbs,
  builder,
  pageSize,
  totals
}) {

  const [pageIndex, setPageIndex] = useState(1)
  const [suburb, setSuburb] = useState(first(suburbs))
  const [priceFrom, setPriceFrom] = useState(first(BUILDER_PROPERTY_PRICE_RANGE))
  const [priceTo, setPriceTo] = useState(first(BUILDER_PROPERTY_PRICE_RANGE))
  const [bed, setBed] = useState(first(HOUSE_BEDROOMS))
  const [bath, setBath] = useState(first(HOUSE_BATHROOMS))
  const [carspaces, setCarspaces] = useState(first(HOUSE_BATHROOMS))

  const [currentTotals, setCurrentTotals] = useState(totals)

  const params = useMemo(() => {
    if (pageIndex === 1 && !suburb.value && !priceFrom.value && !priceTo.value && !bed.value && !bath.value && !carspaces.value) return

    return assign(
      {
        builderBrandId: builder.brand.id,
        limit: pageSize,
        offset: (pageIndex - 1) * pageSize
      },
      suburb.value && { suburbId: suburb.value },
      getPriceQuery(priceFrom.value, priceTo.value, 'price'),
      bed.value && { bedrooms: bed.value },
      bath.value && { bathrooms: bath.value },
      carspaces.value && { carspaces: carspaces.value }
    )
  }, [
    pageIndex,
    suburb,
    priceFrom,
    priceTo,
    bed,
    bath,
    carspaces,
    builder,
    pageSize,
  ])

  const { data, isLoading } = useFetch(params ? { url: 'houses/list', params } : null)
  useEffect(() => {
    if (data) {
      setCurrentTotals(get(data, 'headers.x-total-count', 0))
    } else if (!isLoading) {
      setCurrentTotals(totals)
    }
  }, [data, totals, isLoading])
  const viewData = params ? data : list

  const changeHandle = useCallback(idx => {
    setPageIndex(idx)
  }, [setPageIndex])

  return (
    <div>
      <div className='text-font text-1xl'>All properties by {builder.name}</div>
      <div className='mt-20 flex flex-wrap items-center gap-20'>
        <Select data={suburbs} value={suburb} onChange={setSuburb}></Select>
        <Select prefix='Min Price: ' data={BUILDER_PROPERTY_PRICE_RANGE} value={priceFrom} onChange={setPriceFrom}></Select>
        <Select prefix='Max Price: ' data={BUILDER_PROPERTY_PRICE_RANGE} value={priceTo} onChange={setPriceTo}></Select>
        <Select prefix='Bedrooms: ' data={HOUSE_BEDROOMS} value={bed} onChange={setBed}></Select>
        <Select prefix='Bathrooms: ' data={HOUSE_BATHROOMS} value={bath} onChange={setBath}></Select>
        <Select prefix='Parking: ' data={HOUSE_BATHROOMS} value={carspaces} onChange={setCarspaces}></Select>
      </div>
      <div className='mt-20 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-16'>
        {
          isLoading
            ? (
              map(range(0, 4), idx => (
                <SkeletonCard key={idx}></SkeletonCard>
              ))
            )
            : (
              map(viewData, item => (
                <ListingsStandard data={item} key={item.id}></ListingsStandard>
              ))
            )
        }
      </div>
      {
        !isLoading && currentTotals > pageSize && (
          <Pagination pageIndex={pageIndex} pageSize={pageSize} totals={currentTotals} onChange={changeHandle} center className='mt-30'></Pagination>
        )
      }
    </div>
  )
}